import TYPES from './types';
import { apiClientWithToken, downloadExcelFile } from '../services/backend';
import fileDownload from 'js-file-download';

export const fetchBookMembers = (filter) => {
    return async (dispatch) => {
        try {
            
            const res = await apiClientWithToken().get(
                '/biblioteca-socios', { params: { ...filter } }
            );

            const { ok, result: { data } } = res.data;

            if (ok) {
                dispatch(setBookMembers(data));
                return { ok: true, message: data.message }
            } else {
                return { ok: false, message: data.message };
            }

        } catch (error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' }
        }
    };
};

const setBookMembers = (data) => ({
   type: TYPES.SET_BOOK_MEMBERS, payload: data
});

export const downloadExcel = (filter) => {
    return async () => {
        try {

            const res = await downloadExcelFile(
                '/biblioteca-socios/excel', 
                'socios-biblioteca.xlsx',
                filter,{
                    nombre: 'Alumnos',
                    apellidos: 'Alumnos',
                    email: 'Alumnos'
                }
            );
            const blob = await res.blob();
            fileDownload(blob, 'socios-biblioteca.xlsx');

            return { ok: true };
    
        } catch (error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' };
        }
    };
};

export const setBookMemberFilter = (filter) => ({
    type: TYPES.SET_BOOK_MEMBER_FILTER, payload: filter
});

export const deleteBookMember = (id) => {
    return async () => {
        try {
            
            const res = await apiClientWithToken().delete(
                `/biblioteca-socios/${id}`
            );

            const { ok, result: { data } } = res.data;

            if (ok) {
                return { ok: true, message: data.message };
            } else {
                return { ok: false, message: data.message };
            }

        } catch(error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' };
        }
    };
};

export const sendBookMember = (member) => {
    return async () => {
        try {
            const res = await apiClientWithToken().post(
                '/biblioteca-socios', member
            );
            
            const { ok, result: { data } } = res.data;

            if (ok) {
                return { ok: true, message: data.message };
            } else {
                return { ok: false, message: data.message };
            }

        } catch(error) {
            console.log(error);
            return { ok: false, message: 'message-server-error' };
        }
    };
};